<template>
  <footer class="footer-area footer-default">
    <div class="footer-wrapper">
      <v-row align="end" class="row--0">
        <v-col md="6" sm="12" cols="12">
          <div class="footer-left">
            <div class="inner">
              <span>¿Estas preparado?</span>
              <h2>
                Trabaja <br />
                con nosotros
              </h2>
              <router-link class="rn-button-style--2" to="/contacto"
                ><span>Contacto</span></router-link
              >
            </div>
          </div>
        </v-col>
        <!-- End .col -->
        <v-col md="6" sm="12" cols="12">
          <div class="footer-right" data-black-overlay="6">
            <v-row>
              <!-- Start Single Widget -->
              <v-col lg="6" sm="6" cols="12">
                <div class="footer-widget">
                  <h4>Enlaces rápidos</h4>
                  <ul class="ft-link">
                    <li v-for="(nav, i) in navList" :key="i">
                      <router-link :to="nav.to">{{ nav.navItem }}</router-link>
                    </li>
                  </ul>
                </div>
              </v-col>
              <!-- End Single Widget  -->
              <!-- Start Single Widget -->
              <v-col lg="6" sm="6" cols="12" class="mt_mobile--30">
                <div class="footer-widget">
                  <h4>Contacto</h4>
                  <ul class="ft-link">
                    <li v-for="(mail, i) in mailList" :key="i">
                      <a :href="mail.to">{{ mail.mailItem }}</a>
                    </li>
                  </ul>

                  <div class="social-share-inner">
                    <ul
                      class="social-share social-style--2 d-flex justify-content-start liststyle mt--15"
                    >
                      <li v-for="(social, i) in socialList" :key="i">
                        <a :href="social.url" target="_blank">
                          <i class="fab" :class="social.icon"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </v-col>
              <!-- End Single Widget  -->

              <v-col lg="12">
                <div class="copyright-text">
                  <p>
                    Copyright © {{ new Date().getFullYear() }} Smile Magazine.
                    All Rights Reserved.
                  </p>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <!-- End .col -->
      </v-row>
    </div>
  </footer>
</template>

<script>
  import {container} from "@/main";
  import {FooterService} from "@/pages/layout/footer/footer.service";

  export default {
    async created() {
      this.footerService = container.get(FooterService);
      const footerData = await this.footerService.getFooterData();
      const parser = new DOMParser();
      const doc = parser.parseFromString(footerData.content.rendered, 'text/html');
      // Buscar todos los elementos <ul>
      const uls = doc.querySelectorAll('ul');

      this.socialList = [];
      // Iterar sobre los elementos <ul> y sus enlaces <a>
      uls.forEach(ul => {
        const links = ul.querySelectorAll('a');
        links.forEach(link => {
          const url = link.href;
          if (url.includes('facebook.com')) {
            this.socialList.push({
              icon: "fa-facebook-f",
              url: url,
            });
          } else if (url.includes('linkedin.com')) {
            this.socialList.push({
              icon: "fa-linkedin-in",
              url: url,
            });
          } else if (url.includes('instagram.com')) {
            this.socialList.push({
              icon: "fa-instagram",
              url: url,
            });
          } else if (url.includes('twitter.com')) {
            this.socialList.push({
              icon: "fa-twitter",
              url: url,
            });
          }
        });
      });

      // Buscar todas las filas de la tabla
      const rows = doc.querySelectorAll('table tr');

      this.navList = [];
      // Iterar sobre cada fila para extraer la información
      rows.forEach(row => {
        const cells = row.querySelectorAll('td');
        if (cells.length > 1) {
          const name = cells[0].textContent;
          let link = cells[1].querySelector('a');
          link = link ? link.href : cells[1].textContent;
          this.navList.push({ navItem: name, to: link });
        }
      });
      this.mailList = [];
      const mail = doc.querySelector('body > p > a');
      this.mailList.push({
        mailItem: mail.textContent,
        to: mail.href,
      })
    },
    data() {
      return {
        footerService: null,
        socialList: [
          {
            icon: "fa-facebook-f",
            url: "https://www.facebook.com/SmileMagazineSM",
          },
          {
            icon: "fa-linkedin-in",
            url: "https://www.linkedin.com/company/smilemagazine/",
          },
          {
            icon: "fa-twitter",
            url: "https://twitter.com/SmileMagazineSM",
          },
          {
            icon: "fa-instagram",
            url: "https://www.instagram.com/smilemagazinesm",
          },
        ],
        navList: [
          {
            navItem: "Home",
            to: "/",
          },
          {
            navItem: "Cine & Series",
            to: "blog/categoria/cine-series",
          },
          {
            navItem: "Musica",
            to: "/blog/categoria/musica",
          },
          {
            navItem: "Arte & Cultura",
            to: "/blog/categoria/arte-cultura",
          },
          {
            navItem: "Entrevistas",
            to: "/blog/categoria/entrevistas",
          },
          {
            navItem: `Comunicación`,
            to: "/comunicacion",
          },
        ],
        mailList: [
          {
            mailItem: "info@smilemagazine.com",
            to: "mailto:info@smilemagazine.com",
          },
        ],
      };
    },
  };
</script>
